import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DrawerModule } from 'primeng/drawer';
interface Permissions {
  Id: number;
  Name: string;
  Description: string;
  Category: number;
}

interface IRoles {
  Name: string;
  PermissionLevelId: number;
  Description: string;
}

@Component({
  selector: 'app-admincomponent',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})

export class AdminComponent implements OnInit {
  displayDialog: boolean;
  title = 'ofaccess';
  rolesDB: IRoles[] = [];
  cols: any[];
  items: MenuItem[];
  panelitems: MenuItem[];
  tableItems: MenuItem[];
  permissions;
  roleid;
  showVersionInfo: boolean = false;
  constructor(
    private permissionService: PermissionsService,
    private router: Router,
   private bottomSheet: MatBottomSheet) {
    this.permissionService.selectedrole.subscribe(x => {
      if (x) {
        this.roleid = x.roleId;
        this.setPanelItems();
      }
    });
    this.items = [
      {
        label: 'Spara',
        icon: 'fa fa-save',
        command: () => this.savePermissionState()
      },
      {
        label: 'Ändra',
        icon: 'fa fa-edit'
      }
    ];
  }

  setPanelItems() {
    this.panelitems = [
      {
        label: 'Infosidor',
        items: [
          {
            label: 'Välkomsttext', command: () => this.editWelcomeText()
          },
          { label: 'Servicesidan' }
        ]
      }, {
        label: 'Orsaker',
        items: [
          { label: 'Hantera Orsaker (Causes)', command: () => this.getCauses() }
        ]
      },
      {
        label: 'Institutioner',
        items: [
          {
            label: 'Skapa institution', command: () => this.createInstitution()
          },
          {
            label: 'Institutionstyper (Institution Type)', command: () => this.getInstitutionType()
          },
          {
            label: 'Institutionsgrupper (Institution Group)', command: () => this.getInstitutionGroup()
          }]
      },
      {
        label: 'Ämbeten och Uppdrag',
        items: [
          { label: 'Lista Uppdrag/Ämbeten', command: () => this.getOfficeList() },
          { label: 'Hantera Office_Committee', command: () => this.getOfficeCommittees() },
          { label: 'Hantera Electable_COM', command: () => this.getElectableCommittees() },
          { label: 'Hantera Committee', command: () => this.getCommittees() },
          { label: 'Hantera Office', command: () => this.getOffices() },
          { label: 'Hantera Office_type', command: () => this.getOfficeType() }
        ]
      },
      {
        label: 'Utmärkelser',
        items: [

          { label: 'Hantera Electable_Sign', command: () => this.getElectableSigns() },
          { label: 'Hantera Utmärkelser', command: () => this.getSigns() },
          { label: 'Hantera Sign_type', command: () => this.getSignType() }
        ]
      },
      {
        label: 'Stödtabeller',
        items: [
          { label: 'Hantera Country', command: () => this.getCountries() },
          { label: 'GDPR', command: () => this.GDPR() },
          { label: 'Hantera kontolösa', command: () => this.createAccount() },
          { label: 'Radera medlem vid dubbletter', command: () => this.removeMember() },
          { label: 'Uppdatera medlems betalningar', command: () => this.recalculateFeesMember() }

        ]
      },
      {
        label: 'Systemadministration',
        items: [
          { label: 'Hantera Superanvändare', command: () => this.getSystemPermissionUsers() },
          { label: 'Hantera Systembehörigheter', command: () => this.getSystemAccesses() },
          { label: 'Koppla Uppdrag - Ämbeten <-> Behörighetsroll', command: () => this.connectAccessesAndRoles() },
          { label: 'Lås/Lås upp systemet', command: () => this.lockUnlockSystem() },
          { label: 'Visa versionsinformation', command: () => this.showVersionInformation() }
        ],
        visible: this.permissions?.indexOf('ADMIN_PERMISSIONS') !== -1 && this.roleid === 12
      }
    ];
  }

  savePermissionState() {
  }

  showDialogToAdd() {
    this.displayDialog = true;
  }

  ngOnInit() {
    this.permissionService.selectedrole.subscribe(p => {
      if (p) {
        this.permissions = p.permissions;
      }
    });

    this.cols = [
      { field: 'Name', header: 'Name' },
      { field: 'Description', header: 'Description' },
      { field: 'PermissionLevelId', header: 'PermissionLevelId' },
      { field: 'PermissionLevelName', header: 'PermissionLevelName' }
    ];
  }

  showVersionInformation(): void {
   /*this.bottomSheet.open(InfoComponent, {
      hasBackdrop: true,
      disableClose: false
    });*/
    this.showVersionInfo = true;
  }

  handleItemClick(evt, items) {
    let x = evt;
    let y = items;
  }

  editWelcomeText() {
    this.router.navigateByUrl('/admin/admin_welcomepage');
  }

  getSystemAccesses() {
    this.router.navigateByUrl('/admin/admin_systemaccesses');
  }

  getOffices() {
    this.router.navigateByUrl('/admin/admin_offices');
  }

  getOfficeList() {
    this.router.navigateByUrl('/admin/admin_offices_list');
  }

  getSystemPermissionUsers() {
    this.router.navigateByUrl('/admin/admin_system_permissions');
  }

  connectAccessesAndRoles() {
    this.router.navigateByUrl('/admin/admin_connect_accesses_and_roles');
  }

  createInstitution() {
    this.router.navigateByUrl('/institutions/new?action=new');
  }

  getCauses() {
    this.router.navigateByUrl('/admin/admin_causes');
  }

  getOfficeType() {
    this.router.navigateByUrl('/admin/admin_office_type');
  }

  getCountries() {
    this.router.navigateByUrl('admin/admin_countries');
  }

  getInstitutionType() {
    this.router.navigateByUrl('/admin/admin_institution_type');
  }

  getInstitutionGroup() {
    this.router.navigateByUrl('/admin/admin_institution_group');
  }

  getCommittees() {
    this.router.navigateByUrl('/admin/admin_committees');
  }

  getOfficeCommittees() {
    this.router.navigateByUrl('/admin/admin_office_committees');
  }

  getElectableCommittees() {
    this.router.navigateByUrl('/admin/admin_electable_committees');
  }

  getSigns() {
    this.router.navigateByUrl('/admin/admin_signs');
  }

  getElectableSigns() {
    this.router.navigateByUrl('/admin/admin_electable_signs');
  }

  getSignType() {
    this.router.navigateByUrl('/admin/admin_sign_type');
  }
  lockUnlockSystem() {
    this.router.navigateByUrl('/admin/admin_lock_unlock_system');
  }

  GDPR() {
    this.router.navigateByUrl('/admin/admin_gdpr');
  }

  removeMember() {
    this.router.navigateByUrl('/admin/admin_remove_member');
  }
  recalculateFeesMember() {
    this.router.navigateByUrl('/admin/admin_recalculate_fees_member');
  }
  createAccount() {
    this.router.navigateByUrl('admin/admin_create_account');
  }
}
